import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AddCallPage } from './add-call';

@NgModule({
  declarations: [
    AddCallPage,
  ],
  imports: [
    IonicPageModule.forChild(AddCallPage),
  ],
})
export class AddCallPageModule {}



// WEBPACK FOOTER //
// ./src/pages/add-call/add-call.module.ts